import { clone } from '../../common/common';

// ------------------------------------
// Constants
// ------------------------------------
export const CHAT_LIGHTBOX = 'CHAT_LIGHTBOX';

// ------------------------------------
// Actions
// ------------------------------------

export const openLightbox = image => {
  return { type: CHAT_LIGHTBOX, payload: { image } };
};

export const closeLightbox = () => {
  return { type: CHAT_LIGHTBOX, payload: null };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processLightbox = (state, action) => {
  let newState = clone(state);
  newState.lightboxImage = action.payload ? action.payload.image : null;
  return newState;
};

export const LIGHTBOX_ACTION_HANDLERS = {
  [CHAT_LIGHTBOX]: processLightbox,
};



// WEBPACK FOOTER //
// ./app/javascript/chat/modules/lightbox.js